import { z } from "zod";
import { CloseTemplateBasis } from "./closeTemplateBasis";
import { EntityProfileIndustry, EntityProfileType } from "./entity";
import { TaskTemplateAssigneeRole } from "./taskTemplateAssigneeRole";

export const CloseTemplateSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    serviceId: z.string().uuid().nullable(),
    workspaceId: z.string().uuid().nullable(),
    name: z.string(),
    ownerId: z.number().int().nullable(),
    basis: z.nativeEnum(CloseTemplateBasis).nullable(),
    industries: z.array(z.nativeEnum(EntityProfileIndustry)),
    entityLegalTypes: z.array(z.nativeEnum(EntityProfileType)),
    createdByUserId: z.number().int().nullable(),
    updatedByUserId: z.number().int().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    archivedAt: z.coerce.date().nullable(),
});

export const CloseTemplateWithStatsSchema = CloseTemplateSchema.extend({
    applicationCount: z.number().int().nonnegative(),
    lastAppliedAt: z.coerce.date().nullable(),
    taskCount: z.number().int().nonnegative(),
    scheduleCount: z.number().int().nonnegative(),
    /** Sum of `estimatedTime` (minutes) across all tasks on the template. */
    totalEstimatedTime: z.number().int().nonnegative(),
    /** Sum of `estimatedTime` (minutes) broken down by assignee role, for the hover breakdown. Roles with no estimated time are omitted. */
    estimatedTimeByRole: z.record(
        z.nativeEnum(TaskTemplateAssigneeRole),
        z.number().int().nonnegative(),
    ),
});

export type CloseTemplate = z.infer<typeof CloseTemplateSchema>;
export type CloseTemplateWithStats = z.infer<
    typeof CloseTemplateWithStatsSchema
>;
